import React, {createContext, useState} from "react";
import CRM from "ui/page/CRM";

const defaultContext = {
  appliedFilters: [],
  setAppliedFilters: () => {},
  filtersOpen: false,
  setFiltersOpen: () => {},
  searchText: "",
  setSearchText: () => {},
  customFields: {},
  setCustomFields: () => {},
};

export const CrmContext = createContext(defaultContext);

const CrmPage = () => {
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [customFields, setCustomFields] = useState({});

  const providerData = {
    appliedFilters,
    setAppliedFilters,
    filtersOpen,
    setFiltersOpen,
    searchText,
    setSearchText,
    customFields,
    setCustomFields,
  };

  return (
    <CrmContext.Provider value={providerData}>
      <CRM />
    </CrmContext.Provider>
  );
};

export default CrmPage;
